import type { QueuedRequest, TableConfig } from "../../../types/tables";

import {
  brandCell,
  createdByCell,
  dateCell,
  nameCell,
  queuedNameCell,
  requestDesignTypeCell,
  statusCell,
} from "../../helpers/commonCells";

// Base columns for queued tables
const baseQueuedColumns = [
  {
    accessor: "name" as const,
    cellRenderer: nameCell,
    header: "Name",
    key: "name",
    sortable: true,
    width: 240,
  },
  {
    accessor: "status" as const,
    cellRenderer: statusCell,
    header: "Status",
    key: "status",
    sortable: true,
    width: 180,
  },
  {
    accessor: "brand" as const,
    cellRenderer: brandCell,
    header: "Brand",
    key: "brand",
    sortable: true,
    width: 190,
  },
  {
    accessor: "createdBy" as const,
    cellRenderer: createdByCell,
    header: "Created by",
    key: "createdBy",
    sortable: true,
    width: 140,
  },
  {
    accessor: "createdAt" as const,
    cellRenderer: dateCell,
    header: "Created date",
    key: "createdAt",
    sortable: true,
    width: 130,
  },
  {
    accessor: "requestType" as const,
    cellRenderer: requestDesignTypeCell,
    header: "Request/Design type",
    key: "requestType",
    sortable: true,
    width: 170,
  },
] as const;

// Queued Tab - In Queue Table Configuration
export const queuedInQueueTableConfig: TableConfig<QueuedRequest> = {
  columns: [
    {
      accessor: "name" as const,
      cellRenderer: queuedNameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 240,
    },
    ...baseQueuedColumns.slice(1),
  ],
  enableDragAndDrop: true,
  enablePagination: false,
  enableSorting: false,
  id: "queued-in-queue",
  title: "In Queue",
};

// Queued Tab - Details Needed Table Configuration
export const queuedDetailsNeededTableConfig: TableConfig<QueuedRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 220,
    },
    ...baseQueuedColumns.slice(1),
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  enableDragAndDrop: false,
  enableSorting: true,
  id: "queued-details-needed",
  title: "Details Needed",
};

// Queued Tab - Paused Table Configuration
export const queuedPausedTableConfig: TableConfig<QueuedRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 220,
    },
    ...baseQueuedColumns.slice(1),
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  enableDragAndDrop: false,
  enableSorting: true,
  id: "queued-paused",
  title: "Paused",
};
